import Tooltip from "@mui/material/Tooltip";
import { Verified as VerifiedIcon } from "../icons";
import { T } from "./Translate";

const VerifiedBadge = ({ sx = {} }) => (
  <Tooltip title={<T>Cuenta verificada</T>}>
    <VerifiedIcon
      sx={{
        fontSize: "1rem",
        color: "#3897f0",
        ml: 0.5,
        verticalAlign: "middle",
        ...sx,
      }}
    />
  </Tooltip>
);

export default VerifiedBadge;
